<template>
    <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm8
            md4
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>Login</v-toolbar-title>
                <v-spacer></v-spacer>               
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="loginInfo.username"
                    label="Username"
                    name="login"
                    prepend-icon="mdi-account"
                    type="text"
                  ></v-text-field>

                  <v-text-field
                    v-model="loginInfo.password"
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                  ></v-text-field>
                  <p class="error" v-if="this.loginInfo.invalidFeedback">{{ this.loginInfo.invalidFeedback }}</p>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary"
                @click="login">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
</template>

<script>

import auth from '../store/auth.js'
import  axios  from  'axios';
const SIGNIN_API_URL = 'users/signin';
const MENU_ITEMS_API_URL = 'definitions/menuItems/user/';

export default {
  name: 'login',
  data(){
    return {
        loginInfo:{
            username : '',
            password : '',
            invalidFeedback: ''
        },
    }
  },
  methods: {
    async login() {

        const loginParams = new FormData();
        loginParams.append('username', this.loginInfo.username);
        loginParams.append('password', this.loginInfo.password);
        
        const headers = {
            "Content-Type": "application/x-www-form-urlencoded",            
            "Cache-Control": "no-cache",
        }

        await this.doLogin(this.$apiurl + SIGNIN_API_URL, loginParams,  headers);
        await this.setAuthMenuItems();
        await this.pushToWelcome();
    },
    doLogin : async(url,loginParams,headers) => {
        axios.post(url, loginParams, { headers:  headers})        
        .then(response => {
            localStorage.setItem('access_token', response.headers.access_token)
            localStorage.setItem('refresh_token', response.headers.refresh_token)   
            localStorage.setItem('user_name_surname', response.headers.user_name_surname) 
            localStorage.setItem('user_title', response.headers.user_title)   
            localStorage.setItem('user_id', response.headers.user_id) 
            localStorage.setItem('user_name', response.headers.user_name)      
            auth.dispatch('setUserInfo', { "userNameSurname" : response.headers.user_name_surname,
                                          "userTitle" : response.headers.user_title,
                                          "userId" : response.headers.user_id});
        }) 
        .catch(error => {
            if (error.response.status === 401) {          
              this.loginInfo.invalidFeedback = 'Invalid Username/Password'
            }
            if (error.response.status === 410) {    
              this.loginInfo.invalidFeedback = 'Credentials Expired';
              localStorage.setItem('access_token', '')
              localStorage.setItem('refresh_token', '')
              localStorage.setItem('reset_token', error.response.headers.reset_token) 
              this.$router.push({ name: 'resetPassword' })
            }
        }); 
    },
    async setAuthMenuItems(){
      auth.dispatch('setAuthMenuItems', this.$apiurl + MENU_ITEMS_API_URL + this.loginInfo.username);
    },
    async pushToWelcome(){
      this.$router.push({ name: 'welcome' });
    }
  }
}
</script>